<template>
    <div class="section-block related-block" :class="[data.classname]">
        <header class="block-head">
            <div v-if="!hide_arrow" class="arrow prev" slot="button-prev">←</div>
            <h2 v-html="title"></h2>
            <div v-if="!hide_arrow" class="arrow next" slot="button-next">→</div>
        </header>
        
        <swiper v-if="data" :options="swiper_options" ref="swiper">
            <swiper-slide v-for="(item, index) in data.posts" :key="item.id + '-' + index" :class="['type-'+item.type]">
                <Item :item="item" />
            </swiper-slide>
        </swiper>
    </div>
</template>

<script>
// import '@/assets/svg/side.svg?sprite';
import { Swiper, SwiperSlide } from 'vue-awesome-swiper'
import Item from '@/components/ui/Item.vue';

export default {
    name: 'related-block',

    data() {
        return {
            hide_arrow: false,

            swiper_options: {
                loop: false,
                slidesPerView: 3,
                spaceBetween: 0,
                navigation: {
                    nextEl: '.next',
                    prevEl: '.prev'
                },

            },
        }
    },

    components: {
        Item,
        Swiper,
        SwiperSlide,
    },

    props: {
        data: {
            type: Object,
            default: false
        },
        title: {
            type: String,
            default: ''
        },
    },

    mounted() {
        console.log(this.data)
        // this.$nextTick(()=>{
        //     if (this.data && this.data.medias.length === 1) {
        //         this.hide_arrow = true;
        //     }
        // });

    },
}
</script>

<style lang="scss" scoped>
    .related-block {
        padding: var(--padding);
        border-top: 1px solid;
    }

    .block-head {
        padding: var(--padding);
        position: relative;

        h2 {
            text-align: center;
            text-transform: uppercase;
            font-size: 110%;
        }
    }

    .arrow {
        position: absolute;
        z-index: 9;
        top: 50%;
        height: 1rem;
        width: 1rem;
        margin: -.5rem 0 0;
        cursor: pointer;

        svg {
            height: 100%;
            width: 100%;
            position: absolute;
            top: 0;
            left: 0;
            fill: var(--font-color);
        }

        &.next {
            right: var(--padding);
        }

        &.prev {
            left: var(--padding);
        }

    }
    
    .post-item {
        width: 100%;
    }


</style>
